import { FC, useMemo } from 'react'
import { Button } from '@mui/material'
import { DialogNames } from 'src/enums'
import { useDialog } from 'src/hooks/ui'
import { SensorQualityControlDialog } from './sensorQualityControlDialog'

interface SelectedSensor {
  uniqueId: string
  imei: string | number | null
}

interface SensorQualityControlButtonProps {
  selectedSensors: SelectedSensor[]
}

/** "Quality Control" bulk button shown above the sensors list once devices are selected. */
export const SensorQualityControlButton: FC<SensorQualityControlButtonProps> = ({ selectedSensors }) => {
  const { openDialog, closeDialog } = useDialog(DialogNames.SensorsQualityControl)
  const uniqueIds = useMemo(() => selectedSensors.map((sensor) => sensor.uniqueId), [selectedSensors])

  return (
    <>
      <Button size="large" variant="outlined" onClick={() => openDialog()}>
        Quality Control
      </Button>
      <SensorQualityControlDialog name={DialogNames.SensorsQualityControl} uniqueIds={uniqueIds} onClose={() => closeDialog()} />
    </>
  )
}
